(function () {
  if (window.__rlzCartAddonsBound) return;
  window.__rlzCartAddonsBound = true;

  async function refreshCartDrawer() {
    // Retry once on transient failure (network glitch), then graceful soft-fail
    // (NO full page reload — that would lose the user's PDP context).
    for (var attempt = 0; attempt < 2; attempt++) {
      try {
        const res = await fetch(window.location.pathname + '?section_id=cart-drawer', { cache: 'no-store' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('cart-drawer');
        const current = document.querySelector('cart-drawer');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          if (typeof current.open === 'function') current.open();
          return;
        }
      } catch (e) {
        console.warn('[rlz-cart] refresh attempt ' + (attempt+1) + ' failed:', e);
        if (attempt === 0) await new Promise(function (r) { setTimeout(r, 500); });
      }
    }
    // Final fallback: dispatch event so the page can react (e.g., show toast)
    document.dispatchEvent(new CustomEvent('rlz:cart-refresh-failed'));
  }

  async function addVariant(variantId) {
    const fd = new URLSearchParams();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' }
    });
    if (!r.ok) throw new Error('add failed: ' + r.status);
  }

  async function removeLine(lineKey) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    });
    if (!r.ok) throw new Error('remove failed: ' + r.status);
  }

  // ============ click delegation: salta-coda + generic upsell cards ============
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-rlz-upsell-action]');
    if (!btn) return;
    const card = btn.closest('[data-rlz-upsell-salta-coda]');
    if (!card) return;
    e.preventDefault();
    if (btn.disabled) return;
    const action = btn.dataset.rlzUpsellAction;
    btn.disabled = true;
    let succeeded = false;
    try {
      if (action === 'add') {
        await addVariant(card.dataset.saltaVariant);
      } else if (action === 'remove') {
        await removeLine(card.dataset.saltaLineKey);
      }
      succeeded = true;
      await refreshCartDrawer();
      document.dispatchEvent(new CustomEvent('rlz:cart-updated'));
    } catch (err) {
      console.error('[rlz-upsell]', err);
    } finally {
      // Always re-enable the button if the action failed (refresh handles the success path
      // by replacing the entire drawer DOM, so the disabled button is naturally gone).
      if (!succeeded) btn.disabled = false;
    }
  });

  // ============ change delegation: gift wrap + gift card toggles ============
  document.addEventListener('change', async function (e) {
    const toggle = e.target.closest('[data-rlz-gift-toggle]');
    if (!toggle) return;
    const wrap = toggle.closest('[data-rlz-cart-gift]');
    if (!wrap) return;
    e.preventDefault();
    const kind = toggle.dataset.rlzGiftToggle; // 'wrap' or 'card'
    const variantId = kind === 'wrap' ? wrap.dataset.wrapVariant : wrap.dataset.cardVariant;
    const lineKey = kind === 'wrap' ? wrap.dataset.wrapLineKey : wrap.dataset.cardLineKey;
    if (toggle.disabled) return;
    toggle.disabled = true;
    let succeeded = false;
    try {
      if (toggle.checked) {
        if (!variantId) throw new Error('no variant id for ' + kind);
        await addVariant(variantId);
      } else {
        if (!lineKey) throw new Error('no line key for ' + kind);
        await removeLine(lineKey);
      }
      succeeded = true;
      await refreshCartDrawer();
      document.dispatchEvent(new CustomEvent('rlz:cart-updated'));
    } catch (err) {
      console.error('[rlz-gift]', err);
    } finally {
      if (!succeeded) {
        toggle.checked = !toggle.checked; // revert state
        toggle.disabled = false;
      }
    }
  });

  // ============ input + blur: gift message → line item property on confezione-regalo line ============
  let messageDebounce = null;

  async function fetchCartJson() {
    const r = await fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('cart fetch failed');
    return r.json();
  }

  async function saveGiftMessage(text) {
    const wrap = document.querySelector('[data-rlz-cart-gift]');
    if (!wrap) return;
    // Saved on the confezione-regalo line. If not in cart yet, do nothing
    // (the textarea is hidden anyway when wrap is OFF).
    const lineKey = wrap.dataset.wrapLineKey;
    if (!lineKey) return;
    const propertyKey = wrap.dataset.msgPropertyKey || 'Messaggio regalo';
    const aliasesRaw = wrap.dataset.msgPropertyAliases || '';
    const aliases = aliasesRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    const cart = await fetchCartJson();
    const item = cart.items.find(function (it) { return it.key === lineKey; });
    if (!item) return;
    const existing = item.properties || {};
    const merged = {};
    Object.keys(existing).forEach(function (k) {
      if (aliases.indexOf(k) !== -1) return;
      merged[k] = existing[k];
    });
    if (text && text.trim().length > 0) {
      merged[propertyKey] = text.trim();
    }

    const r = await fetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: lineKey, properties: merged }),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    });
    if (!r.ok) throw new Error('msg save failed: ' + r.status);

    const savedFlag = document.querySelector('[data-rlz-gift-msg-saved]');
    if (savedFlag) {
      savedFlag.hidden = false;
      setTimeout(function () { savedFlag.hidden = true; }, 1800);
    }
    document.dispatchEvent(new CustomEvent('rlz:cart-updated'));
  }

  document.addEventListener('input', function (e) {
    const ta = e.target.closest('[data-rlz-gift-message]');
    if (!ta) return;
    const counter = document.querySelector('[data-rlz-gift-msg-count]');
    if (counter) counter.textContent = String(ta.value.length);
    clearTimeout(messageDebounce);
    messageDebounce = setTimeout(function () {
      saveGiftMessage(ta.value).catch(function (err) { console.error('[rlz-gift-msg]', err); });
    }, 800);
  });

  document.addEventListener('blur', function (e) {
    const ta = e.target.closest && e.target.closest('[data-rlz-gift-message]');
    if (!ta) return;
    clearTimeout(messageDebounce);
    saveGiftMessage(ta.value).catch(function (err) { console.error('[rlz-gift-msg]', err); });
  }, true);
})();
